import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlHelper } from "../../classes/urlHelper";

@Injectable({
  providedIn: 'root'
})
export class LogTimeService {
  getLogTimeInfo(targetId, type) {
    return this.httpClient.get<any>(`/api/LogTime/GetLogTimeInfo?type=${type}&targetId=${targetId}`);
  }

  startLogTime(targetId, type) {
    return this.httpClient.get<any>(`/api/LogTime/StartLogTime?type=${type}&targetId=${targetId}`); 
  }

  stopLogTime(targetId, type) {
    return this.httpClient.get<any>(`/api/LogTime/StopLogTime?type=${type}&targetId=${targetId}`); 
  }

  calculateDesPoint(targetId, type) {
    return this.httpClient.get<any>(`/api/LogTime/CalculateDesPoint?type=${type}&targetId=${targetId}`);
  }

  updateDesPointFromManager(targetId, desPoint) {
    return this.httpClient.get<any>(`/api/LogTime/updateDesPointFromManager?targetId=${targetId}&desPoint=${desPoint}`);
  }

  constructor(private httpClient: HttpClient) { }
}
